const noAuthorizedInterceptor = () => ({
  onFulfilled: (response) => response,
  onRejected: (error) => {
    return Promise.reject(error);
  }
});

export default noAuthorizedInterceptor;